import React, { memo, useState, useEffect, Fragment } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, TableContainer } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { wsFindBy } from 'services/WService';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold'
  }
});

export default WithApp(function ModalOuput(props) {
  const cuota = props.model;
  const { purchaseData, purchRetention, purchRetentionDocument, reload } = props;
  const [dataChanging, setDataChanging] = useState(purchRetentionDocument || {});

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }


  return (
    <>
      <Modal 
        title={`Validación de recibo por honorario`}
        model={{ open: props.open }}
        setOpen={props.onClose}
        showNotify={props.showNotify}
        reload={reload}
        entity={'purch/purchase-retention'}
        arrDataResponse
        dataForce={{
          purch_purchase_id: purchaseData.id,
          wtliable: purchRetentionDocument[0]?.wtliable,
          u_syp_mntdet: purchRetentionDocument[0]?.u_syp_mntdet,
          WTCode: purchRetentionDocument[0]?.WTCode,
        }}
      >
        <TextField
          label="Código"
          fullWidth
          type="text"
          name="code"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          value={purchRetentionDocument[0]?.WTCode || ''}
        />
        <TextField
          label="Descripción"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          value={purchaseData.details[0]?.Dscription || ''}
        />
        <TextField
          label="Tipo"
          fullWidth
          type="text"
          name="type"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          value={purchRetentionDocument[0]?.WTName || ''}
        />
        <TextField
          label="Tasa"
          fullWidth
          type="number"
          name="rate"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          value={purchRetentionDocument[0]?.Rate || ''}
        />
        <TextField
          label="Importe"
          fullWidth
          type="number"
          name="basic_import"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          value={purchaseData.DocTotal || ''}
        />
        <TextField
          label="Retención"
          fullWidth
          type="number"
          name="wtliable_retention"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          value={purchaseData.DocTotal * (purchRetentionDocument[0]?.Rate / 100) || ''}
        />
      </Modal>
    </>
  );
});

